export default function ServiceAreas() {
  const areas = [
    'Merced', 'Atwater', 'Livingston', 'Los Banos', 'Turlock',
    'Modesto', 'Fresno', 'Madera', 'Chowchilla', 'Gustine',
    'Newman', 'Patterson', 'Hilmar', 'Delhi', 'Winton'
  ];

  return (
    <section id="service-areas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Service Areas
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Proudly serving Merced, CA and surrounding communities with professional water damage restoration services
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Areas We Serve</h3>
              <div className="grid grid-cols-2 gap-4">
                {areas.map((area, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-map-pin-line text-teal-600 mr-2"></i>
                    <span className="text-gray-700 text-sm font-medium">{area}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-teal-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                <i className="ri-map-pin-2-line text-teal-600 mr-2"></i>
                Primary Service Location
              </h3>
              <p className="text-gray-700 mb-4">
                <strong>Indoor-Restore Services</strong><br />
                1729 U St, Merced, CA 95340<br />
                <span className="text-gray-500 text-sm">Serving Merced County &amp; Central Valley</span>
              </p>
              <a href="tel:2094512288" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 cursor-pointer">
                <i className="ri-phone-line mr-2"></i>
                (209) 451-2288
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50678.12345678!2d-120.4829!3d37.3022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8090a8e3b3b3b3b3%3A0x1234567890abcdef!2sMerced%2C%20CA!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Indoor-Restore Services location map - Merced CA"
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
